// extracted by mini-css-extract-plugin
export var clickBlocker = "_fr-c";
export var interactivePassthrough = "_fr-4";
export var lookHere = "_fr-3";
export var modal = "_fr-e";
export var modalBackdrop = "_fr-d";
export var modalBody = "_fr-p";
export var modalBodyHero = "_fr-q";
export var modalDescription = "_fr-s";
export var modalEnter = "_fr-f";
export var modalFooter = "_fr-t";
export var modalFooterHero = "_fr-u";
export var modalHeaderText = "_fr-n";
export var modalHeroImage = "_fr-i";
export var modalHeroTitle = "_fr-l";
export var modalIconCircle = "_fr-o";
export var modalIconHeader = "_fr-m";
export var modalImageLabel = "_fr-k";
export var modalImageOverlay = "_fr-j";
export var modalImageWrapper = "_fr-h";
export var modalTitle = "_fr-r";
export var modalWithHero = "_fr-g";
export var pulse = "_fr-1";
export var pulseBorder = "_fr-2";
export var spotlight = "_fr-0";
export var tooltip = "_fr-5";
export var tooltipButtons = "_fr-a";
export var tooltipDescription = "_fr-7";
export var tooltipFooter = "_fr-8";
export var tooltipInteractiveHint = "_fr-b";
export var tooltipStepIndicator = "_fr-9";
export var tooltipTitle = "_fr-6";